export class ErrorModel {
    status: number;
    detail: string;

    constructor(errorCode: number, info: string) {
        this.status = errorCode;
        this.detail = info;
    }
}
